import { useMemo } from 'react';
import clsx from 'clsx';
import { SelectDropdown } from '@/components/ui/SelectDropdown/SelectDropdown';
import {
  normalizeReaderCooperationState,
  READER_COOPERATION_ICON_CLASS,
  READER_COOPERATION_MENU_ORDER,
  type ReaderCooperationStateValue,
} from '@/utils/readerCooperationStates';
import '@/components/StatusSelect/StatusSelect.css';

interface ReaderCooperationSelectProps {
  /** Подпись над полем (если не задана — только тултип `title`) */
  label?: string;
  /** Текст подсказки при наведении на блок выбора */
  title?: string;
  value: string;
  onChange: (value: ReaderCooperationStateValue) => void;
  fullWidth?: boolean;
  disabled?: boolean;
}

export function ReaderCooperationSelect({
  label,
  title = 'Сотрудничество',
  value,
  onChange,
  fullWidth,
  disabled,
}: ReaderCooperationSelectProps) {
  const displayValue = normalizeReaderCooperationState(value);

  const options = useMemo(
    () => READER_COOPERATION_MENU_ORDER.map((s) => ({ value: s, label: s })),
    []
  );

  return (
    <div className="status-select" title={title || undefined}>
      <SelectDropdown
        options={options}
        value={displayValue}
        onChange={(v) => onChange(normalizeReaderCooperationState(v))}
        label={label}
        fullWidth={fullWidth}
        disabled={disabled}
        renderValue={(selected) => {
          const v = (selected?.value ?? displayValue) as ReaderCooperationStateValue;
          const fa = READER_COOPERATION_ICON_CLASS[v];
          return (
            <span className="status-select__value">
              <i className={clsx(fa, 'status-select__icon')} aria-hidden />
              <span className="status-select__text">{selected?.label ?? displayValue}</span>
            </span>
          );
        }}
        renderOption={(opt) => (
          <>
            <i
              className={clsx(READER_COOPERATION_ICON_CLASS[opt.value as ReaderCooperationStateValue], 'status-select__option-icon')}
              aria-hidden
            />
            <span className="status-select__option-text">{opt.label}</span>
          </>
        )}
      />
    </div>
  );
}
